<template>
  <DpplTooltip
    :tooltip-offset="8"
    :tooltip-placement="tooltipPlacement"
    :hide-tooltip="hideTooltip || !dateRange.length"
  >
    <template #activator="{ onMouseenter, onMouseleave }">
      <span
        class="activator-text"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
      >
        {{ activatorText }}
      </span>
    </template>
    <template #tooltip-content>
      <p
        v-if="currentDateToShow"
        class="tooltip-content text-body-3"
      >
        {{ currentDateToShow }}
      </p>
    </template>
  </DpplTooltip>
</template>

<script setup>
import { computed } from 'vue';
import { formatRange } from '@/helpers/date';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

const props = defineProps({
  activatorText: {
    type: String,
    required: true,
  },
  dateRange: {
    type: Array,
    default: () => ([]),
  },
  hideTooltip: {
    type: Boolean,
    default: false,
  },
  tooltipPlacement: {
    type: String,
    default: 'top',
  },
});

const currentDateToShow = computed(() => formatRange(props.dateRange));
</script>

<style lang="less" scoped>
.tooltip-content {
  color: @text-dark;
  white-space: nowrap;
}
</style>
